import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

// ----------------------------------------------------------------------

RHFDateField.propTypes = {
  name: PropTypes.string,
  max_value: PropTypes.string,
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  date: PropTypes.string,
  maxDate: PropTypes.string,
  minDate: PropTypes.string,
};

export default function RHFDateField({
  disabled = false,
  label,
  name,
  max_value,
  date,
  helperText,
  maxDate,
  minDate,
  ...other
}) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          maxDate={maxDate}
          minDate={minDate}
          disabled={disabled}
          {...field}
          label={label}
          value={field?.value && moment(field.value)._d}
          onChange={(v) => field.onChange(moment(v).format("YYYY-MM-DD"))}
          slotProps={{
            textField: {
              helperText: (
                <span style={{ color: "red" }}>{error?.message}</span>
              ),
            },
          }}
        />
      )}
    />
  );
}
